export default __webpack_public_path__ + "static/media/step6.000d3a86.svg";